import styled from 'styled-components';

const TableWrapper = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
`;

const StyledTable = styled.table`
  min-width: 100%;
  background-color: white;
  border-collapse: separate;
  border-spacing: 0;
`;

const TableIcons = styled.div`
  color: #adacb6;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  > * {
    margin: 10px;
    margin-left: 0;
    cursor: black pointer;
  }
  span {
    text-transform: capitalize;
  }
`;

const RowHeader = styled.tr`
  min-width: 100%;
`;

const ColumnHeader = styled.th`
  line-height: 0px;
  font-size: 0px;
  font-weight: 600;
  color: #393b3c;
  text-align: left;
  height: 0px;
  span {
    font-size: 0px;
    display: flex;
    align-items: center;
  }
  position: relative;
  cursor: pointer;
  top: 0;
  background: ${({ theme }) => theme.COLOR_TABLE_DARK};
  border-bottom: 1px solid #d8d8d8;
  &:nth-child(1) {
    padding: 0 0px;
  }
  height: 0px;
  top: -5px;
`;

const ColumnHeaderNoPadding = styled.th`
  line-height: 24px;
  font-size: 14px;
  font-weight: 600;
  color: #393b3c;
  text-align: left;
  height: 48px;
  padding: 0;
  span {
    display: flex;
    align-items: center;
  }
  position: relative;
  cursor: pointer;
  top: 0;
  background: ${({ theme }) => theme.COLOR_TABLE_DARK};
  border-bottom: 1px solid #d8d8d8;
  &:nth-child(1) {
    padding: 0 25px;
  }
`;

const Row = styled.tr`
  border-bottom: 1px solid #e3e3e3;
  min-width: 100%;
  background: ${({ theme }) => theme.COLOR_TABLE_DARK};
  transition: background-color 0.3s ease-in-out;
  &.clickable {
    cursor: pointer;
    @media (hover: hover) {
      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }
`;

const SubRow = styled.tr`
  border-bottom: 1px solid #e3e3e3;
  min-width: 100%;
  transition: background-color 0.3s ease-in-out;
  background: ${({ theme }) => theme.COLOR_TABLE_DARK};
  -moz-box-shadow: inset 0 0 1px #e3e3e3;
  -webkit-box-shadow: inset 0 0 1px #e3e3e3;
  box-shadow: inset 0 0 1px #e3e3e3;
  @media (hover: hover) {
    &:hover {
      background: ${({ theme }) => theme.COLOR_BG_DARK};
    }
  }
`;

const Text = styled.span`
  font-size: 18px;
  font-weight: 400;
  color: ${(theme) => theme.COLOR_TABLE_DARK};
`;
const Column = styled.td`
  margin: 0;
  font-size: 14px;
  color: #707172;
  line-height: 16px;
  height: 64px;
  border-bottom: 1px solid #e3e3e3;
  &:nth-child(1) {
    padding: 0 25px;
  }
  word-wrap: break-word;
  white-space: normal;
`;

const LoadingText = styled.span`
  font-size: 18px;
  font-weight: 400;
  color: ${({ theme }) => theme.COLOR_PRIMARY};
`;

const DropDownHolder = styled.span`
  position: relative;
  margin: 0;
  z-index: 9999 !important;
`;

const Div = styled.div`
  width: 100%;
`;

const TableContainer = styled.div`
  overflow: hidden;
  width: 100%;

  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background: white;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    border-radius: 5px;
    background: rgba(0, 0, 0, 0.2);
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 5px;
  }

  scrollbar-face-color: rgba(0, 0, 0, 0.3); /* Firefox 63 compatibility */
  scrollbar-track-color: rgba(0, 0, 0, 0.2); /* Firefox 63 compatibility */
  scrollbar-color: rgba(0, 0, 0, 0.3) rgba(0, 0, 0, 0.2);
  scrollbar-width: thin;
`;

const StyledSubTable = {
  TableWrapper,
  StyledTable,
  TableIcons,
  RowHeader,
  ColumnHeader,
  ColumnHeaderNoPadding,
  Row,
  SubRow,
  Text,
  Column,
  LoadingText,
  DropDownHolder,
  Div,
  TableContainer,
};

export default StyledSubTable;
